module.exports = __webpack_public_path__ + "static/media/BatchSend.1141ffac.svg";